import {
  getApplicationListV2,
  getServiceApplicationsInServiceCollection,
  getServiceApplicationSubscriptionStatusForIdentity,
  linkServiceApplicationToServiceCollection,
  unlinkServiceApplicationFromServiceCollection,
} from "../../actions/api";
import { getServiceCollection } from "../../actions/api";
import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, List, Popconfirm, Space, Tooltip } from "antd";
import PropTypes from "prop-types";
import { connect, useSelector } from "react-redux";
import {
  AppstoreAddOutlined,
  AppstoreOutlined,
  DeleteOutlined,
  EditOutlined,
  LinkOutlined,
} from "@ant-design/icons";
import { PageHeader2, ServiceHeader } from "../headers/PageHeaders";
import ApplicationSearch from "../common/ApplicationSearch";
import { applicationPortal, service_admin_role } from "../../config";
import { NavLink, useParams } from "react-router-dom";
import { DatabaseOutlined, SettingOutlined } from "@ant-design/icons/lib";
import { selectHasRole } from "./UtilsAdmin";
import UserStatusModal from "./UserStatusModal";

const ServiceApplicationsListAdmin = ({
  getServiceCollection,
  getApplicationListV2,
  getServiceApplicationsInServiceCollection,
  linkServiceApplicationToServiceCollection,
  unlinkServiceApplicationFromServiceCollection,
  serviceCollection,
  serviceApplications,
  applications,
  isLoading,
  getServiceApplicationSubscriptionStatusForIdentity,
}) => {
  const [serviceCollectionIsAdmin, setServiceCollectionIsAdmin] =
    useState(false);
  const isServiceAdmin = useSelector(selectHasRole(service_admin_role));
  const { serviceCollectionId } = useParams();

  useEffect(() => {
    getServiceApplicationsInServiceCollection(serviceCollectionId);
  }, [getServiceApplicationsInServiceCollection, serviceCollectionId]);

  useEffect(() => {
    if (serviceCollection) {
      setServiceCollectionIsAdmin(
        applications.some(
          (x) =>
            serviceCollection.applicationIdentifier === x.applicationIdentifier,
        ),
      );
      if (isServiceAdmin) setServiceCollectionIsAdmin(true);
    }
  }, [serviceCollection, applications, isServiceAdmin]);

  useEffect(() => {
    getApplicationListV2();
    getServiceCollection(serviceCollectionId);
  }, [getServiceCollection, serviceCollectionId, getApplicationListV2]);

  const selectApplication = async (application) => {
    await linkServiceApplicationToServiceCollection(
      serviceCollectionId,
      application.applicationIdentifier,
    );
    await getServiceApplicationsInServiceCollection(serviceCollectionId);
  };

  const unlinkApplication = async (application) => {
    await unlinkServiceApplicationFromServiceCollection(
      application.applicationIdentifier,
    );
    await getServiceApplicationsInServiceCollection(serviceCollectionId);
  };

  return (
    <div>
      <Breadcrumb
        items={[
          {
            title: <NavLink to="/manage">Service Collections</NavLink>,
          },
          {
            title: `Service Applications for ${serviceCollection?.applicationIdentifier}`,
          },
        ]}
      />

      <ServiceHeader
        title={serviceCollection?.displayName}
        subTitle={serviceCollection?.description}
        loading={isLoading}
      />

      <PageHeader2
        title="Managed Applications"
        subTitle="Applications are (web) application access rights, service access rights, licences, etc."
        icon={<AppstoreOutlined />}
      />

      <List
        loading={isLoading}
        dataSource={serviceApplications}
        renderItem={(item) => (
          <List.Item
            actions={[
              <UserStatusModal
                key="zz0"
                application={item}
                getStatusForIdentity={
                  getServiceApplicationSubscriptionStatusForIdentity
                }
              />,
              <Tooltip
                key="zz1"
                title="Edit this Application in the Application Portal"
              >
                <Button
                  icon={<EditOutlined />}
                  href={`${applicationPortal}manage/${item.applicationIdentifier}`}
                  target="_blank"
                  disabled={!serviceCollectionIsAdmin}
                />
              </Tooltip>,
              <Tooltip
                key="zz2"
                title="Edit this Application Subscription Settings"
              >
                <NavLink
                  to={`/manage/${serviceCollectionId}/application/${item.applicationIdentifier}`}
                >
                  <Button
                    icon={<SettingOutlined />}
                    disabled={!serviceCollectionIsAdmin}
                  />
                </NavLink>
              </Tooltip>,
              <Tooltip
                key="zz3"
                title="Edit this Application Managed Resource Types"
              >
                <NavLink
                  to={`/manage/${serviceCollectionId}/application/${item.applicationIdentifier}/managedresourcetype`}
                >
                  <Button
                    icon={<DatabaseOutlined />}
                    disabled={!serviceCollectionIsAdmin}
                  />
                </NavLink>
              </Tooltip>,
              <Tooltip
                key="zz4"
                title="Unmap Application from the Service Collection"
              >
                <Popconfirm
                  title="Unmap Application from the Service Collection"
                  description="Are you sure to unmap this application ?"
                  onConfirm={() => unlinkApplication(item)}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="Cancel"
                >
                  <Button danger icon={<DeleteOutlined />} />
                </Popconfirm>
              </Tooltip>,
            ]}
          >
            <List.Item.Meta
              title={
                <Space>
                  <NavLink
                    to={`/manage/${serviceCollectionId}/application/${item.applicationIdentifier}/managedresources`}
                  >
                    {item.displayName}
                  </NavLink>
                </Space>
              }
              description={item.description}
            />
          </List.Item>
        )}
        locale={{
          emptyText: "No applications you are allowed to manage were found.",
        }}
      />

      <div
        style={{
          backgroundColor: "#f3f4f5",
          padding: "5px",
        }}
      >
        <p>
          To add a new application to this Service Collection, first create an
          application if needed on the Application Portal then map it to this
          Service Collection using the buttons below.
        </p>
        <Tooltip title="Create a new Application on the Application Portal">
          <Button
            icon={<AppstoreAddOutlined />}
            href={applicationPortal}
            target="_blank"
            disabled={!serviceCollectionIsAdmin}
          />
        </Tooltip>
        <ApplicationSearch
          title="Map an Application to Service Collection"
          icon={<LinkOutlined />}
          onSelect={selectApplication}
          disabled={!serviceCollectionIsAdmin}
        />
      </div>
    </div>
  );
};

ServiceApplicationsListAdmin.propTypes = {
  getServiceApplicationsInServiceCollection: PropTypes.func.isRequired,
  linkServiceApplicationToServiceCollection: PropTypes.func.isRequired,
  unlinkServiceApplicationFromServiceCollection: PropTypes.func.isRequired,
  getServiceCollection: PropTypes.func.isRequired,
  getApplicationListV2: PropTypes.func.isRequired,
  serviceApplications: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  serviceCollection: PropTypes.object,
  applications: PropTypes.array,
  getServiceApplicationSubscriptionStatusForIdentity: PropTypes.func.isRequired,
};

//export default ServiceApplicationsList;
export default connect(
  (state) => ({
    serviceCollection: state.serviceCollection.data,
    applications: state.applications.data,
    serviceApplications: state.serviceApplications.data,
    isLoading: state.serviceApplications.loading,
  }),
  {
    getServiceApplicationsInServiceCollection,
    linkServiceApplicationToServiceCollection,
    unlinkServiceApplicationFromServiceCollection,
    getServiceCollection,
    getApplicationListV2,
    getServiceApplicationSubscriptionStatusForIdentity,
  },
)(ServiceApplicationsListAdmin);
